import VideoBlock from '../../videoBlock';
import React from 'react';
import { getCurrentLocale } from '../../../../utils/getCurrentLocale';
import { useDevicesScreen } from '../../../../utils/useDevicesScreen';

const VideoBlockWrapper = (props) => {
  const  { showAu, showNz, showOnDesktop, showOnTablet, showOnMobile, videoId, ...data } = props;

  const locale = getCurrentLocale();
  const { isMobile, isTablet, isDesktop, isLargeDesktop } = useDevicesScreen();

  if ((locale === 'AU' && !showAu) || (locale === 'NZ' && !showNz)) {
    return null;
  }

  if (
    ((isDesktop || isLargeDesktop) && !showOnDesktop) ||
    (isTablet && !showOnTablet) ||
    (isMobile && !showOnMobile)
  ) {
    return null;
  }

  return (
    <VideoBlock
      {...data}
      videoId={videoId}
      sourceJs={JSON.stringify(data.sourceJs)}
    />
  )
}

export default VideoBlockWrapper;
